import React from 'react';
// import PageFooter from 'glic-ui-components/dist/js/PageFooter';
// import Text from 'glic-ui-components/dist/js/Text';
// import TextLink from 'glic-ui-components/dist/js/TextLink';
import { TextLink, PageFooter, Text, Button } from 'glic-ui-components';
import { Link } from 'react-router-dom';
const Footer = () => {

    const gotoLink = (evt) => {
        evt.preventDefault();
        window.open(evt.target.id,
            "_blank", "width=900, height=600");
    }
    const currentYear = new Date().getFullYear();
    const openOneTrust = (e) => {
        e.preventDefault();
        if (
            typeof window !== 'undefined' &&
            window.OneTrust &&
            window.OneTrust.ToggleInfoDisplay
        ) {
            window.OneTrust.ToggleInfoDisplay();
        }
    };
    return (


        <PageFooter
            elementProps={{ logo: { style: { display: "none" } } }}
            disclaimer={"© " + currentYear + ", Managed Dental Care, P.O. Box 25256, Lehigh Valley, PA. 18002-5256, USA."}
            footerText={[
                <Text disclaimer onDarkBackground>
                    Note: Free language assistance services are available for you and your dependents to assist with your dental needs. Please contact MDC’s Member Services Department at 1-800-273-3330, your assigned network general dentist or your network specialist (for MDC approved specialty care) if English is not your or your dependents’ preferred spoken or written language.<br /><br />
                    Copies of all Vital Plan Documents translated into Spanish are available by contacting MDC's Member Services Department at 1-800-273-3330.<br /><br />
                    <span lang="es">
                        Nota: Los servicios gratuitos de ayuda con el idioma están disponibles para usted y sus dependientes para ayudarle con sus necesidades dentales. Si el inglés no es el idioma preferido de usted o sus dependientes, por favor comuníquese a nuestro Departamento de Servicios para Miembros al 1-800-273-3330, su dentista general de red asignada o su especialista de red (para una atención especializada de MDC).
                        <br /><br />Todas las copias de los documentos vitales de el plan tradudidos a español están disponibles comunicandose a MDC el departamento de servicios al cliente a el 1-800-273-3330.
                        <br /><br /></span>
                    We are committed to protecting your privacy. Read our <TextLink
                        onDarkBackground={true}
                        inlineSize="body-sm"
                        id="https://www.guardianlife.com/privacy-policy"
                        onClick={gotoLink}>
                        privacy policies
                    </TextLink> for more information.<br /><br />
                    <TextLink
                        onDarkBackground={true}
                        inlineSize="body-sm"
                        id="cstgs"
                        onClick={openOneTrust}>
                        Do not sell or share my personal information
                    </TextLink>
                </Text>
            ]}
            socialMedia={{
                facebook: { link: 'https://www.facebook.com/guardianlife/', show: false },
                instagram: { link: 'https://instagram.com/guardianlife', show: false },
                linkedIn: { link: 'https://www.linkedin.com/company/the-guardian-life-insurance-company-of-america_164085?trk=company_logo', show: false },
                twitter: { link: 'https://twitter.com/intent/follow?source=followbutton&variant=1.0&screen_name=guardianlife', show: false },
                youtube: { link: 'https://www.youtube.com/c/guardianlife', show: false }
            }}
        />
    )
}

export default Footer
